/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RunColorEntityRefDTO } from './RunColorEntityRefDTO';
import {
    RunColorEntityRefDTOFromJSON,
    RunColorEntityRefDTOFromJSONTyped,
    RunColorEntityRefDTOToJSON,
} from './RunColorEntityRefDTO';

/**
 * 
 * @export
 * @interface QueryRunColorsParamsDTO
 */
export interface QueryRunColorsParamsDTO {
    /**
     * 
     * @type {string}
     * @memberof QueryRunColorsParamsDTO
     */
    colorListName: string;
    /**
     * 
     * @type {Array<RunColorEntityRefDTO>}
     * @memberof QueryRunColorsParamsDTO
     */
    entities: Array<RunColorEntityRefDTO>;
    /**
     * 
     * @type {string}
     * @memberof QueryRunColorsParamsDTO
     */
    projectIdentifier: string;
}

/**
 * Check if a given object implements the QueryRunColorsParamsDTO interface.
 */
export function instanceOfQueryRunColorsParamsDTO(value: object): value is QueryRunColorsParamsDTO {
    if (!('colorListName' in value) || value['colorListName'] === undefined) return false;
    if (!('entities' in value) || value['entities'] === undefined) return false;
    if (!('projectIdentifier' in value) || value['projectIdentifier'] === undefined) return false;
    return true;
}

export function QueryRunColorsParamsDTOFromJSON(json: any): QueryRunColorsParamsDTO {
    return QueryRunColorsParamsDTOFromJSONTyped(json, false);
}

export function QueryRunColorsParamsDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): QueryRunColorsParamsDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'colorListName': json['colorListName'],
        'entities': ((json['entities'] as Array<any>).map(RunColorEntityRefDTOFromJSON)),
        'projectIdentifier': json['projectIdentifier'],
    };
}

export function QueryRunColorsParamsDTOToJSON(value?: QueryRunColorsParamsDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'colorListName': value['colorListName'],
        'entities': ((value['entities'] as Array<any>).map(RunColorEntityRefDTOToJSON)),
        'projectIdentifier': value['projectIdentifier'],
    };
}

